import {defineStore} from 'pinia';
import axios from "axios";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export const contentReviewStore = defineStore('contentReviewStore',{
    state: () => ({
        crItemProposersModalState: false,
        crItemProposers: []
    }),
    actions: {
        toggleCrItemProposersModalState() {
            this.crItemProposersModalState = !this.crItemProposersModalState;
        },
        showCrProposersModal(proposalIssueNumber) {
            baseLoaderStore().showBaseLoader();
            this.getCrItemProposers(proposalIssueNumber);
        },
        getCrItemProposers(issueNumber) {
            baseLoaderStore().showBaseLoader();
            return axios.get(`/api/proposals?issueNumbers=${issueNumber}&page=0&size=10&statuses=CURRENT&statuses=ARCHIVED`)
                .then((res) => {
                    let proposalId = res.data.content.length > 0 ? res.data.content[0].id : null;

                    return axios.get(`/api/proposals/${proposalId}`)
                        .then((res) => {
                            this.crItemProposers = res.data.extraAttributes.spokes;
                            this.toggleCrItemProposersModalState();
                            baseLoaderStore().hideBaseLoader();
                        });
            });
        },

    }
});